import React from 'react';
import Footer from './Footer';
import SidebarContent from './SidebarContent';
import { Link } from "react-router-dom";

// Figma side menu(15:848)左上字標;客戶提供的 SVG 原件(單色 currentColor,側欄深底 → 白)
import { DckLogo } from "../../components/DCKeeper/ui/DckLogo";

import { connect } from "react-redux";
import { changeSidebarType } from "../../store/actions";

const Sidebar = (props) => {

    function tToggle() {
        var body = document.body;
        if (window.screen.width <= 998) {
            body.classList.toggle("sidebar-enable");
            body.classList.remove("right-bar-enabled");
        } else {
            body.classList.toggle("sidebar-enable");
            body.classList.toggle("vertical-collpsed");
            body.classList.remove("right-bar-enabled");
            body.setAttribute("data-sidebar-size", "sm");
        }
    }

    return (
        <React.Fragment>
            <div className="vertical-menu">
                <div className="navbar-brand-box">
                    <Link to="/" className="logo logo-dark">
                        <span className="logo-sm"><DckLogo height={16} variant="mark" /></span>
                        <span className="logo-lg"><DckLogo height={25.27} /></span>
                    </Link>

                    <Link to="/" className="logo logo-light">
                        <span className="logo-lg"><DckLogo height={25.27} /></span>
                        <span className="logo-sm"><DckLogo height={16} variant="mark" /></span>
                    </Link>
                </div>

                <button type="button" className="btn btn-sm px-3 header-item vertical-menu-btn topnav-hamburger" onClick={() => tToggle()}>
                    <div className="hamburger-icon">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </button>

                <SidebarContent />

                <Footer />
            </div>
        </React.Fragment>
    );
};

// export default Sidebar;

const mapStateToProps = state => {
    return { ...state.Layout };
};

export default connect(mapStateToProps, {

    changeSidebarType,

})(Sidebar);

